export default __webpack_public_path__ + "static/media/female_alt.106a05bf.png";